export default "__VITE_ASSET__CqoDnPac__"